$(document).on('click', '.btn-pass-rate-recruiters-total, .btn-pass-rate-sources-total, .btn-pass-rate-categories-total, .btn-pass-rate-departments-total', (e) => {
  e.preventDefault();
  const type = $(e.target).data('type');

  $(`.btn-pass-rate-${type}-percentage`).removeClass('is-selected');
  $(`.btn-pass-rate-${type}-ratios`).removeClass('is-selected');
  $(`.btn-pass-rate-${type}-total`).addClass('is-selected');

  $(`.pass-rate-${type}-total`).removeClass('is-hidden');
  $(`.pass-rate-${type}-percentage`).addClass('is-hidden');
  $(`.pass-rate-${type}-ratio`).addClass('is-hidden');

  $(`.table-footer-pass-rate-${type}-totals`).removeClass('is-hidden');
});

$(document).on('click', '.btn-pass-rate-recruiters-percentage, .btn-pass-rate-sources-percentage, .btn-pass-rate-categories-percentage, .btn-pass-rate-departments-percentage', (e) => {
  e.preventDefault();
  const type = $(e.target).data('type');

  $(`.btn-pass-rate-${type}-total`).removeClass('is-selected');
  $(`.btn-pass-rate-${type}-ratios`).removeClass('is-selected');
  $(`.btn-pass-rate-${type}-percentage`).addClass('is-selected');

  $(`.pass-rate-${type}-total`).addClass('is-hidden');
  $(`.pass-rate-${type}-percentage`).removeClass('is-hidden');
  $(`.pass-rate-${type}-ratio`).addClass('is-hidden');

  $(`.table-footer-pass-rate-${type}-totals`).removeClass('is-hidden');
});

$(document).on('click', '.btn-pass-rate-recruiters-ratios, .btn-pass-rate-sources-ratios, .btn-pass-rate-categories-ratios, .btn-pass-rate-departments-ratios', (e) => {
  e.preventDefault();
  const type = $(e.target).data('type');

  $(`.btn-pass-rate-${type}-total`).removeClass('is-selected');
  $(`.btn-pass-rate-${type}-percentage`).removeClass('is-selected');
  $(`.btn-pass-rate-${type}-ratios`).addClass('is-selected');

  $(`.pass-rate-${type}-ratio`).removeClass('is-hidden');
  $(`.pass-rate-${type}-total`).addClass('is-hidden');
  $(`.pass-rate-${type}-percentage`).addClass('is-hidden');

  $(`.table-footer-pass-rate-${type}-totals`).addClass('is-hidden');
});
